import { render } from "./TheCheckboxConfirmDialogModal.vue?vue&type=template&id=c229b830"
import script from "./TheCheckboxConfirmDialogModal.vue?vue&type=script&lang=js"
export * from "./TheCheckboxConfirmDialogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__